import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

const AGENT_REGISTRATION_API_URL = 'https://login.flymiles.com.au/api_sections/agents_dashboard/agent_signup.php';

export function registerAgent(payload) {
    return axios.post(AGENT_REGISTRATION_API_URL, payload).then((response) => {
        if (response.data && response.data.error) {
            return Promise.reject({ response: { data: response.data } });
        }
        return response;
    });
}

const LOGIN_API_URL = 'https://login.flymiles.com.au/api_sections/agents_dashboard/login.php';
// API has no token/expiry concept, so we bound the local session ourselves.
const SESSION_DURATION_SECONDS = 24 * 60 * 60;

export function login(email, password) {
    return axios.post(LOGIN_API_URL, { email, password }).then((response) => {
        if (response.data && response.data.error) {
            return Promise.reject({ response: { data: response.data } });
        }
        const { password: _password, ...agent } = response.data;
        return {
            ...response,
            data: {
                ...agent,
                idToken: String(agent.id),
                expiresIn: SESSION_DURATION_SECONDS,
            },
        };
    });
}

export function formatApiError(errorResponse, fallbackMessage = 'Something went wrong. Please try again.') {
    const message = errorResponse && errorResponse.error && errorResponse.error.trim();
    swal('Oops', message || fallbackMessage, 'error');
}

export function formatLoginError(errorResponse) {
    const message = errorResponse && errorResponse.error && errorResponse.error.trim();
    switch (message) {
        case 'Login Credentials Failed':
            swal('Oops', 'Invalid email or password', 'error', { button: 'Try Again!' });
            break;
        case 'Missing parameters':
            swal('Oops', 'Please enter your email and password', 'error');
            break;
        default:
            formatApiError(errorResponse);
    }
}

const UPDATE_PROFILE_API_URL = 'https://login.flymiles.com.au/api_sections/agents_dashboard/update_profile.php';
const UPLOAD_LOGO_API_URL = 'https://login.flymiles.com.au/api_sections/agents_dashboard/compay_image_update.php';

function rejectIfApiError(response) {
    if (response.data && response.data.error) {
        return Promise.reject({ response: { data: response.data } });
    }
    return response;
}

export function updateProfile(payload) {
    return axios.post(UPDATE_PROFILE_API_URL, payload).then(rejectIfApiError);
}

export function uploadCompanyLogo(agentId, base64Image) {
    return axios
        .post(UPLOAD_LOGO_API_URL, { agent_id: agentId, image: base64Image })
        .then(rejectIfApiError);
}

export function updateStoredUserDetails(patch) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) return;
    const tokenDetails = JSON.parse(tokenDetailsString);
    localStorage.setItem('userDetails', JSON.stringify({ ...tokenDetails, ...patch }));
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
